/** @jsxRuntime classic */ /** @jsx createElement */ import { createElement } from '@fluentui/react-jsx-runtime';
import { getSlotsNext } from '@fluentui/react-utilities';
import { Portal } from '@fluentui/react-portal';
/**
 * Render the final JSX of PopoverSurface
 */ export const renderPopoverSurface_unstable = (state)=>{
    const { slots , slotProps  } = getSlotsNext(state);
    const surface = /*#__PURE__*/ createElement(slots.root, slotProps.root, state.withArrow && /*#__PURE__*/ createElement("div", {
        ref: state.arrowRef,
        className: state.arrowClassName
    }), slotProps.root.children);
    if (state.inline) {
        return surface;
    }
    return /*#__PURE__*/ createElement(Portal, {
        mountNode: state.mountNode
    }, surface);
};
